<script context="module">
    import { uuid } from '../Database.svelte';
    import {writable} from "svelte/store";
    import parseFields from '../Utilities/parseFields'

    let modals = writable([]);

    export function showMappingModal() {
        return new Promise((resolve, reject) => {
            let modal = {
                id: uuid()
            }

            modal.saveAction = (data) => {
                closeModal(modal.id);
                resolve(data);
            };

            modal.cancelAction = () => {
                closeModal(modal.id);
                reject("cancel");
            };

            modal.deleteAction = () => {
                closeModal(modal.id);
                reject("delete");
            };

            modals.update(m => [...m, modal]);
        })
    }

    export function closeModal(id) {
        modals.update(m => m.filter((i) => i.id != id))
    }

</script>

<script>
    import {onMount} from "svelte";

    import SortableTable from './SortableTable.svelte';
    import positiveControlModel from '../Models/positiveControlModel';
    import serviceRecommendationModel from '../Models/serviceRecommendationModel';
    import Recommendation from '../Models/recommendationModel';
    import Library from '../Models/libraryORM'
    import {tables} from '../lib/tables'

    export let assessment_type;

    let library_unsub;
    let library_sortFields;
    let library_items;

    let selected_section = assessment_type.report_sections.filter(s => s.section_type == "library")[0];

    function getLibraryData(selected_section) {
        if (!selected_section) return;

        if (library_unsub) {
            // unsubscribe from previous library
            library_unsub();
            library_unsub = undefined;
        }

        let library_model = new Library(selected_section.library_type);

        library_unsub = library_model.store.subscribe((lib) => {
            if (!lib) return;

            let fieldData = parseFields(lib.fields)

            library_sortFields = fieldData.sortFields;
            library_items = lib.items.items;

        })
    }

    onMount(() => {
        return () => {
            if (library_unsub) {
                library_unsub()
            }
        }
    })

    $: getLibraryData(selected_section);
</script>

{#each $modals as modal}
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card is-fullwidth">
            <header class="modal-card-head">
                <p class="modal-card-title">Create Mapping</p>
                <button class="delete" aria-label="close" on:click={modal.cancelAction}></button>
            </header>
            <section class="modal-card-body">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <span class="label">Library Section</span>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control select is-fullwidth">
                                    <select bind:value={selected_section}>
                                        {#each assessment_type.report_sections as section}
                                            {#if section.section_type == "library"}
                                                <option value={section}>{section.section_name}</option>
                                            {/if}
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {#if selected_section}
                        <SortableTable sortFields={library_sortFields} tableData={library_items} ORM="true">
                            <div slot="rowActions" let:row={item}>
                                <div class="button is-success" on:click={() => modal.saveAction({
                                    type: "library_item",
                                    section_id: selected_section.section_id,
                                    id: item.details._id
                                })}>
                                    Select Item
                                </div>
                            </div>
                        </SortableTable>
                    {/if}
            </section>
            <footer class="modal-card-foot has-text-right">
                <button class="button is-pulled-right" on:click={modal.cancelAction}>Close</button>
            </footer>
        </div>
    </div>
{/each}

<style>
    .field-label {
        flex-grow: 0;
        flex-basis: content;
    }
</style>